module.exports = __webpack_public_path__ + "assets/images/ert3.602af9d6acaee96cecee1090fc28613a.png";